import React from 'react';
import {
  FormField,
  FormHelp,
  Grid,
  Heading,
  IconWarningOutline,
  Label,
  Paragraph,
  Textarea,
} from '@zillow/constellation';
import { Controller, useFormContext } from 'react-hook-form';

export function ZipMismatch() {
  const {
    formState: { errors },
  } = useFormContext<{ message: string }>();

  return (
    <Grid display="grid" gridTemplateColumns="repeat(12, 1fr)" style={{ minHeight: '100%' }}>
      <Grid gridColumnEnd={{ default: 'span 12', lg: 'span 8', xl_gte: 'span 7' }}>
        <Grid display="grid" gridTemplateColumns="repeat(12, 1fr)" marginTop="xl">
          <Grid gridColumnEnd={{ default: 'span 1', lg: 'span 2' }}></Grid>
          <Grid gridColumnEnd={{ default: 'span 10', lg: 'span 8' }}>
            <IconWarningOutline marginY="md" fontColor="brand" size="lg" />
            <Heading level={4} as="h2" fontFamily="serif">
              Let your applicant know to update their application
            </Heading>
            <Paragraph marginY="sm">
              The address this applicant entered is different than the one you added. In order to send you the correct
              background and credit reports, the applicant needs to update the address on their end and resubmit the
              application. This ensures they can review any changes to their reports before applying
            </Paragraph>
            <Controller
              name="message"
              rules={{
                required: 'A message is required',
                maxLength: { value: 250, message: 'Please enter a message under 250 characters' },
              }}
              render={({ field }) => {
                return (
                  <FormField
                    label={<Label>Preview and customize your message</Label>}
                    control={<Textarea {...field} />}
                    description={<FormHelp>{errors.message ? errors.message.message : 'Max characters: 250'}</FormHelp>}
                    error={!!errors.message}
                  />
                );
              }}
            />
          </Grid>
          <Grid gridColumnEnd={{ default: 'span 1', lg: 'span 2' }}></Grid>
        </Grid>
      </Grid>
      <Grid gridColumnEnd={{ default: 'span 12', lg: 'span 4', xl_gte: 'span 5' }}></Grid>
    </Grid>
  );
}
